export default __webpack_public_path__ + "static/media/disable-cursor.2968ef23.svg";